module.exports = function () {
    var $lottieFiles = $('[data-lottie-src]');

    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    var lottieIeFixer = function (el) {
        if (!isIE11) {
            return;
        }

        var width = el.clientWidth;
        var svg = el.querySelector('svg');

        var ratio = width / svg.width.baseVal.value;

        var newWidth = width + 'px';
        var newHeight = (svg.height.baseVal.value * ratio) + 'px';

        svg.style.width = newWidth;
        svg.style.height = newHeight;
    };

    var isPlayEnabled = function (el) {
        var playEnabledState = false;
        var playTrigger = $(el).data('playTrigger');

        if (playTrigger.length) {
            var bounding = el.getBoundingClientRect();
            
            if (playTrigger == 'playWhenTopIsVisible') {
                playEnabledState = (bounding.top <= window.innerHeight && bounding.left >= 0 && bounding.right <= window.innerWidth);
            }
            else if (playTrigger == 'playWhenBottomIsVisible') {
                var isTallerThanViewport = bounding.height > window.innerHeight;

                if (isTallerThanViewport) {
                    playEnabledState = (bounding.top <= window.innerHeight / 2 && bounding.left >= 0 && bounding.right <= window.innerWidth && bounding.bottom > window.innerHeight);
                } else {
                    playEnabledState = (bounding.top >= 0 && bounding.left >= 0 && bounding.right <= window.innerWidth && bounding.bottom <= window.innerHeight);
                }
            }
        }

        return playEnabledState;
    }

    $lottieFiles.each(function () {
        var $lottieFile = $(this);
        var el = $lottieFile[0];
        var path = $lottieFile.data('lottieSrc');
        var loopLottie = $lottieFile.data('loopLottie');
        
        var animation = lottie.loadAnimation({
            container: el,
            renderer: 'svg',
            loop: loopLottie,
            autoplay: false,
            path: path
        });

        animation.addEventListener('data_ready', function () {            
            if (isPlayEnabled(el)) {
                animation.play();
            }
            else {
                var hasPlayed = false;

                $(window).scroll(function () {
                    if (!hasPlayed) {                        
                        if (isPlayEnabled(el)) {
                            animation.play();
                            hasPlayed = true;
                        }
                    }
                });
            }
        });

        if (isIE11) {
            animation.addEventListener('DOMLoaded', function () {
                lottieIeFixer(el);
            });

            $(window).resize(function () {
                requestAnimationFrame(function () {
                    lottieIeFixer(el);
                });
            });
        }
    });
};